'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var ImageGallery = function ImageGallery(_ref) {var onClick = _ref.onClick,index = _ref.index,children = _ref.children,className = _ref.className;
  var handleClick = function handleClick() {
    if (onClick) {
      onClick(index);
    }
  };

  return (
    _react2.default.createElement('div', { onClick: handleClick, className: className },
      children));


};exports.default =

ImageGallery;

ImageGallery.propTypes = {
  index: _propTypes2.default.number,
  onClick: _propTypes2.default.func,
  children: _propTypes2.default.element,
  className: _propTypes2.default.string };module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/PropertyDetailedInfo/PropertyDetails/ImageGallery.js
// module id = 2836
// module chunks = 0